export default "__VITE_ASSET__Dx_745dl__"